import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  template: `
		<!-- <img
			class="animate-duration-infinite h-20 w-20 animate-spin-clockwise animate-iteration-count-infinite"
			ngSrc="/assets/images/logos/main-logo.webp"
			alt="Logo principal"
			width="80"
			height="80"
			[priority]="priority"
		/> -->
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
			<circle fill="#0D97FF" stroke="#0D97FF" stroke-width="15" r="15" cx="40" cy="65">
				<animate
					attributeName="cy"
					calcMode="spline"
					dur="2"
					values="65;135;65;"
					keySplines=".5 0 .5 1;.5 0 .5 1"
					repeatCount="indefinite"
					begin="-.4"
				></animate>
			</circle>
			<circle fill="#0D97FF" stroke="#0D97FF" stroke-width="15" r="15" cx="100" cy="65">
				<animate
					attributeName="cy"
					calcMode="spline"
					dur="2"
					values="65;135;65;"
					keySplines=".5 0 .5 1;.5 0 .5 1"
					repeatCount="indefinite"
					begin="-.2"
				></animate>
			</circle>
			<circle fill="#0D97FF" stroke="#0D97FF" stroke-width="15" r="15" cx="160" cy="65">
				<animate
					attributeName="cy"
					calcMode="spline"
					dur="2"
					values="65;135;65;"
					keySplines=".5 0 .5 1;.5 0 .5 1"
					repeatCount="indefinite"
					begin="0"
				></animate>
			</circle>
		</svg>
	`
})
export class LoaderComponent {
	@Input() priority: boolean = true;
}
